<template>
  <div class="vis-card" @click="handleCardClick">
    <div class="vis-card-header">
      <h3 class="vis-title">{{ visData.brand_name }} {{ isSecondCard ? '' : 'V' + visData.version }}</h3>
      <span class="vis-version">V{{ visData.version }}</span>
    </div>
    <div class="vis-card-body">
      <img 
        v-if="brandLogo" 
        :src="brandLogo" 
        :alt="visData.brand_name + ' logo'" 
        class="vis-logo"
      />
      <div v-else class="vis-logo-placeholder">
        {{ getInitials(visData.brand_name) }}
      </div>
    </div>
    <div class="vis-card-footer">
      <div class="vis-date">{{ formatDate(visData.release_date) }}</div>
      <div class="vis-id">{{ formatId(visData.id) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VISCard',
  props: {
    visData: {
      type: Object,
      required: true
    },
    isSecondCard: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    brandLogo() {
      // Prefer explicit brand_logo field returned by the API (flat structure)
      if (this.visData.brand_logo) {
        return this.visData.brand_logo;
      }

      // Fall back to nested brand.logo if the payload contains a brand object
      if (this.visData.brand && this.visData.brand.logo) {
        return this.visData.brand.logo;
      }
      
      // Otherwise return null - will show placeholder with initials
      return null;
    }
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB'); // DD/MM/YYYY format
    },
    formatId(id) {
      // Pad the ID with zeros to get 6 digits
      return id.toString().padStart(6, '0');
    },
    getInitials(name) {
      if (!name) return '';
      
      return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase();
    },
    handleCardClick() {
      this.$emit('click', this.visData.id);
    }
  }
};
</script>

<style scoped>
.vis-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  height: 100%;
}

.vis-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.vis-card-header {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.vis-title {
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
}

.vis-version {
  background-color: #f0f0f0;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.8rem;
  font-weight: 600;
}

.vis-card-body {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  min-height: 140px;
}

.vis-logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  overflow: hidden;
}

.vis-logo-placeholder {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e94057;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  font-weight: 600;
}

.vis-card-footer {
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  background-color: #f9f9f9;
  font-size: 0.8rem;
  color: #777;
}

.vis-date, .vis-id {
  padding: 0;
}
</style> 